// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardPreviewInfo_container__i5sLI"};